import { render } from "./popover_Uikit.vue?vue&type=template&id=7a028712"
import script from "./popover_Uikit.vue?vue&type=script&lang=js"
export * from "./popover_Uikit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__